import { getGroceriesPageName } from './getGroceriesPageName';
import { type Location } from './pairingInteraction';
import { analytics } from './segment';

type Action = 'clicked' | 'added_to_cart' | 'removed_from_cart';

type ProductInteractionParams = {
  productId: number;
  actionType: Action;
  productName?: string;
  location?: Location;
  orderId?: number;
};

export const productInteraction = ({
  productId,
  actionType,
  productName,
  location,
  orderId,
}: ProductInteractionParams) => {
  analytics.track('product_interaction', {
    product_id: productId,
    product_name: productName,
    action_type: actionType,
    location,
    page_name: getGroceriesPageName(),
    order_id: orderId,
  });
};
